import {
  ChangeDetectionStrategy,
  Component,
  signal,
  inject,
} from '@angular/core';

import { RemindPasswordFormComponent } from '../../components/remind-password-form/remind-password-form.component';
import { HttpErrorService } from '@web/common';
import { FormTitleWithSubtitleComponent } from '../../ui/form-title-with-subtitle/form-title-with-subtitle.component';
import { RemindPasswordForm } from '../../models/remind-password-form';
import { AlertsComponent, AlertsService } from '@web/shared/ui';
import { HttpErrorResponse } from '@angular/common/http';
import { once } from '@web/utils';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-remind-password',
  imports: [
    FormTitleWithSubtitleComponent,
    RemindPasswordFormComponent,
    AlertsComponent,
  ],
  templateUrl: './remind-password.component.html',
  styleUrl: './remind-password.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [AlertsService],
})
export class RemindPasswordComponent {
  private readonly auth = inject(AuthService);
  private readonly alerts = inject(AlertsService);
  private readonly httpError = inject(HttpErrorService);

  protected readonly isFormVisible = signal<boolean>(true);

  public handleSubmitClickEvent(form: RemindPasswordForm): void {
    this.auth
      .remindPassword(form)
      .pipe(once())
      .subscribe({
        next: () => {
          this.showSuccessAlert();
          this.markFormAsInvisible();
        },
        error: (response) => {
          this.showFailureAlertByResponse(response);
        },
      });
  }

  private showSuccessAlert(): void {
    this.alerts.showSingle((builder) =>
      builder
        .initSuccess(
          'Jeśli konto jest zarejestrowane w naszej bazie, otrzymasz wiadomość e-mail z instrukcjami dotyczącymi resetowania hasła. Sprawdź swoją skrzynkę, aby kontynuować proces.',
        )
        .closeable(false)
        .build(),
    );
  }

  private showFailureAlertByResponse(response: HttpErrorResponse): void {
    const messages = this.httpError.extract(response).messages();

    this.alerts.showMultiple((builder) =>
      messages.map((message) => builder.buildFailure(message)),
    );
  }

  private markFormAsInvisible(): void {
    this.isFormVisible.set(false);
  }
}
